const baseStyle = {
  color: `heading`,
  fontSize: `md`,
  fontWeight: `semibold`,
  height: `auto`,
  lineHeight: `normal`,
  p: 4,
  _placeholder: {
    color: `placeholder`,
  },
};

const variants = {
  outline: {
    border: `2px solid`,
    borderColor: `border`,
  },
};

export const Textarea = {
  baseStyle,
  variants,
};
